import React, { Component } from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';

// Brand Headers
import wigs from '../img/brand/girls_hair.png'
import postMastectomy from '../img/brand/post_mastectomy.png'
import bras from '../img/brand/girl_bra.png'
import undergarments from '../img/brand/girl_undergarments.png'
import cleanser from '../img/brand/girl_sitting.png'
import girlSwim from '../img/brand/girl_swim.png'
import rocks from '../img/brand/rocks.png'
import makeup from '../img/brand/girl_makeup.png'

// Components
import BrandSection from './BrandSection'


class Brands extends Component {
  render() {
    return (
      <div>
      <ParallaxProvider>
        <BrandSection title="Wigs" background={wigs} brands={["JON RENAU","NORIKA","EXPRESSION","REVELON","NEW IMAGE","RAQUEL WELSH","GABOR","LA VIE"]}/>
        <BrandSection title="Bras" background={bras} brands={["PANACHE/ SCULPTRESS AND CLEO","GODDESS","ELOMI","WOCOAL","ROSA FAIA","CHANTELLE","CLAVIN KLEIN"]}/>
        <BrandSection title="Post Mastectomy" background={postMastectomy} brands={["ANITA", "AMOENA"]}/>
        <BrandSection title="Swim Suits" background={girlSwim} brands={["ANITA", "ROSA FAIA"]}/>
        <BrandSection title="Undergarments" background={undergarments} brands={["WARNER", "BLUSH", "CHANTELLE", "HANKY PANKY", "ANITA"]}/>
        <BrandSection title="Head Gear" background={rocks} brands={["AMOENA"]}/>
        <BrandSection title="Creams/Cleanser" background={cleanser} brands={["COSMIC TREE"]}/>
        <BrandSection title="Make Up" background={makeup} brands={["COSMIC TREE"]}/>
      </ParallaxProvider>
      </div>
    );
  }
}

export default Brands;



// WEBPACK FOOTER //
// ./src/components/Brands.js